import { apiGet } from '../../api'

export const delete_event = id => {
  return apiGet({
    endpoint: `events/delete_event?id=${id}`
  })
}
